<mat-card class="card-style px-6 py-6 pt-0">
  <div class="mt-6">
    <div>
      @if (!loading) {
        <h3>
          Deseja excluir o
          {{ typeClient == 'client' ? 'Cliente' : 'Subcliente' }}:
        </h3>
        <p>
          <strong>Razão social:</strong> {{ item.nomeFantasia }} <br />
          <strong>Cnpj:</strong> {{ item.cnpj | cnpj }}
        </p>
        <div class="flex justify-between gap-2">
          <button
            mat-flat-button
            class="btn-tg-cancel w-4/12"
            (click)="close()"
          >
            Cancelar
          </button>
          <button mat-flat-button class="btn-tg w-4/12" (click)="deleteItem()">
            Excluir
          </button>
        </div>
      } @else {
        <h3>
          Aguarde {{ typeClient == 'client' ? 'Cliente' : 'Subcliente' }} sendo
          excluido.
        </h3>

        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</mat-card>
